export default {
  'validators.tinNumberFormat':
    'Please enter a valid TIN number (e.g. 123-456-789-001 or 123-456-789-12345)',
  'validators.phoneNumberFormat':
    'Please enter a valid Philippine mobile number',
};
